/*
    Returns the only element of an  array with length one (showing only 20 chars), 
    or shortens the array to a string indicating the number of elements
*/

import shortenStr from './shortenStr';

const shortenArr = (arr, elementName) =>
    arr.length === 1 ? shortenStr(20, arr[0]) : `${arr.length} ${elementName}`;

export default shortenArr;
